import { useState } from "react";

interface Props {
  requestId: string;
}

export function RequestIdBadge({ requestId }: Props) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(requestId).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        color: "#94a3b8",
        fontSize: 12,
      }}
    >
      <span>Error · request </span>
      <code style={{ background: "#1e293b", padding: "2px 6px", borderRadius: 4 }}>
        {requestId}
      </code>
      <button
        type="button"
        onClick={copy}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "#64748b",
          fontSize: 11,
        }}
      >
        {copied ? "copied" : "copy"}
      </button>
    </div>
  );
}
